export const ROUTE_403_PATH = '/403';
export const ROUTE_404_PATH = '/404';
export const ROUTE_BACKEND_NO_SIGNAL_PATH = '/---';
